// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1_Jqm","author":"Table_author__QERsU","authorImage":"Table_authorImage__qwS2n","unreadRow":"Table_unreadRow__1IMsf"};